import React, { useCallback } from 'react';
import { useEffect, useRef, useState } from 'react';
import './webcam-capture.scss';
import { AppButton } from '../buttons/app-button';
import { useIntl } from 'react-intl';
import { homeSpecimenUploadDialogMessages } from 'azshared';

export interface WebcamCaptureProps {
  onPhotoTaken: (dataUrl: string) => void;
}

const WebcamCapture = (props: WebcamCaptureProps) => {
  const { formatMessage } = useIntl();
  const { onPhotoTaken } = props;

  const videoRef = useRef<HTMLVideoElement | null>(null);
  const canvasRef = useRef<HTMLCanvasElement | null>(null);

  const [stream, setStream] = useState<MediaStream | null>(null);

  // start webcam video stream, user for web (webcam)
  useEffect(() => {
    let currentStream: MediaStream | null = null;
    const startWebcam = async () => {
      try {
        const mediaStream = await navigator.mediaDevices.getUserMedia({
          video: { facingMode: 'user' },
          audio: false
        });

        currentStream = mediaStream;
        setStream(mediaStream);

        if (videoRef.current) {
          videoRef.current.srcObject = mediaStream;
        }
      } catch (err) {
        console.error('Errore accesso webcam:', err);
      }
    };

    startWebcam();

    return () => {
      // Stop webcam quando il componente viene smontato
      currentStream?.getTracks().forEach((track) => track.stop());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // take a frame from the video stream and get url encoded data
  const takePhoto = useCallback(() => {
    const video = videoRef.current;
    const canvas = canvasRef.current;

    if (!video || !canvas) return;

    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    ctx.drawImage(video, 0, 0);
    const imageData = canvas.toDataURL('image/png');

    // Stop all tracks to release the webcam
    stream?.getTracks().forEach((track) => track.stop());

    onPhotoTaken?.(imageData);
  }, [onPhotoTaken, stream]);

  return (
    <div className='webcam-capture'>
      <video className='video-capture' ref={videoRef} autoPlay playsInline />
      <AppButton label={formatMessage(homeSpecimenUploadDialogMessages.takePhotoActionLabel)} className='take-photo-button' onClick={takePhoto} />
      <canvas ref={canvasRef} className='hidden-canvas' />
    </div>
  );
};

export default WebcamCapture;
